module.exports = __webpack_public_path__ + "static/img/item-l_c_mango.7bbd6fa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/item-l_c_mango.png
// module id = SCD5
// module chunks = 1